var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H24C27.3137 0 30 2.68629 30 6V24C30 27.3137 27.3137 30 24 30H6C2.68629 30 0 27.3137 0 24V6Z",
    fill: "#316BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1819_5680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76953 15.4282V7.60817C5.76953 6.59254 6.59284 5.76923 7.60847 5.76923H15.4285C15.9162 5.76923 16.384 5.96298 16.7288 6.30785L24.8463 14.4253C25.5644 15.1435 25.5644 16.3078 24.8463 17.026L17.0263 24.846C16.3081 25.5641 15.1438 25.5641 14.4256 24.846L6.30815 16.7285C5.96328 16.3837 5.76953 15.9159 5.76953 15.4282V15.4282ZM10.0604 8.22115C9.04476 8.22115 8.22145 9.04446 8.22145 10.0601C8.22145 11.0757 9.04476 11.899 10.0604 11.899C11.076 11.899 11.8993 11.0757 11.8993 10.0601C11.8993 9.04446 11.076 8.22115 10.0604 8.22115Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1819_5680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6154,
    height: 19.6154,
    fill: "white",
    transform: "translate(5.76953 5.76923)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.29cca9e1c6402838e75a5b542b02599f.svg";
export { ForwardRef as ReactComponent };